<script>
    import { showMessage, messageObject } from "../stores.js";

    import { fly } from "svelte/transition";

    export let style;

    // disappearing message
    $: {
        if ($messageObject.showMessage) {
            console.log("showing message");
            setTimeout(() => {
                $messageObject.showMessage = false;
            }, 2000);
        }
    }
</script>

{#if $messageObject.showMessage}
    <div
        {style}
        in:fly={{ y: -100, duration: 500 }}
        out:fly={{ y: -100, duration: 500 }}
        class="message"
        class:success={$messageObject.type == "success"}
        class:error={$messageObject.type == "error"}
        class:info={$messageObject.type == "info"}
    >
        {$messageObject.message}

        <i
            class="close fas fa-times"
            on:click={() => ($messageObject.showMessage = false)}
        />
    </div>
{/if}

<style>
    .message {
        width: 100%;
        position: absolute;
        top: 50px;
        z-index: 98;

        display: flex;
        padding: 10px;
        align-items: center;
        justify-content: center;
    }

    .close {
        margin-left: 10px;
    }

    .message i {
        opacity: 0.3;
    }

    .message i:hover {
        cursor: pointer;
        opacity: 1;
    }

    .success {
        background: rgb(52, 174, 66);
        color: white;
    }

    .error {
        background: rgb(209, 45, 45);
        color: white;
    }

    .info {
        background: rgb(251, 234, 105);
    }
</style>
